import type { CSSProperties } from 'react'

// Minimal structural styles that don't depend on theme colors
export const CARD_STYLE: CSSProperties = {
  marginBottom: 16,
}
